import { useState, useEffect } from "react";

export const useMinimumLoading = (isLoading: boolean, minDuration: number = 400): boolean => {
  const [isLoadingStable, setIsLoadingStable] = useState(isLoading);
  const [loadingStartTime, setLoadingStartTime] = useState<number | null>(null);

  useEffect(() => {
    if (isLoading) {
      setIsLoadingStable(true);
      if (loadingStartTime === null) {
        setLoadingStartTime(Date.now());
      }
      return;
    }

    if (loadingStartTime !== null) {
      const elapsed = Date.now() - loadingStartTime;
      const remaining = Math.max(0, minDuration - elapsed);

      const timer = setTimeout(() => {
        setIsLoadingStable(false);
        setLoadingStartTime(null);
      }, remaining);

      return () => clearTimeout(timer);
    } else {
      setIsLoadingStable(false);
    }
  }, [isLoading, loadingStartTime, minDuration]);

  return isLoadingStable;
};
